import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import { signIn } from 'next-auth/react'

export const Route = createFileRoute('/_auth/refresh-session')({
  component: RefreshSessionRoute
})

function RefreshSessionRoute() {
  useEffect(() => {
    signIn('refresh-session', {
      callbackUrl: '/',
      redirect: false
    })
  }, [])

  return null
}
